import React, { Component } from "react";
import { connect } from "react-redux";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import Container from "../../../../../modules/commons/Container";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL } from "../../../../common/mapper";
import { fetchDataAsync } from "../../../../../Services/Utils";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import DailySalesReport from "../components/dailySalesReport";
import DailySalesLeasingReport from "../components/dailySalesLeasingReport";
import MonthToDateReport from "../components/monthToDateReport";
import YearToDateReport from "../components/yearToDateReport";
import LastThreeYearsReport from "../components/lastThreeYearsReport";

class TLReportByTL extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            kodeCabang: [],
            search: null,
            idLeader: null,
        };
    };

    componentDidMount = async () => {
        this.fetchDataCabang();
        this.fetchLeaderId();
    };

    fetchLeaderId = async () => {
        let idLeader = localStorage.getItem("idLeader");
        if (idLeader) {
            this.setState((prevValue) => ({
                ...prevValue,
                idLeader: idLeader,
            }));
            return;
        }
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(this.props.auth.user.idUser),
                menuName: "Dashboard Level Team Leader - Laporan Harian By Team Leader",
                setError: this.props.setError,
            });
            if (res.ok) {
                localStorage.setItem("idLeader", res.data.data.id);
                this.setState((prevValue) => ({
                    ...prevValue,
                    idLeader: res.data.data.id,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
        this.handleTriggerLoading();
    }

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
                menuName: "Dashboard Level Team Leader - Laporan Harian By Team Leader",
                setError: this.props.setError,
            });
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: this.state.kodeCabang?.value,
        }));
    };

    render() { 
        return (
            <>
                <Container>
                    <FlexView style={{ gap: "20px", alignItems: "center" }}>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-350px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            isClearable
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleButton
                            styles={{ marginBottom: "15px" }}
                            onClick={this.handleSearch}
                        >Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Laporan Jualan Harian</Tab>
                            <Tab>Laporan Jualan Harian Leasing</Tab>
                            <Tab>Laporan Jualan MTD</Tab>
                            <Tab>Laporan Jualan YTD</Tab>
                            <Tab>Laporan Jualan 3 Tahun Terakhir</Tab>
                        </TabList>
                        <TabPanel>
                            <DailySalesReport
                                {...this.props}
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <DailySalesLeasingReport
                                {...this.props}
                                tab="teamLead"
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <MonthToDateReport
                                {...this.props}
                                tab="teamLead"
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <YearToDateReport
                                {...this.props}
                                tab="teamLead"
                                kodeCabang={this.state.kodeCabang}
                                idLeader={this.state.idLeader}
                                search={this.state.search}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <LastThreeYearsReport
                                {...this.props}
                                tab="teamLead"
                                kodeCabang={this.state.kodeCabang}
                                idLeader={this.state.idLeader}
                                search={this.state.search}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
            </>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TLReportByTL);